module.exports = __webpack_public_path__ + "img/login.4eec3484.jpg";